module.exports = __webpack_public_path__ + "static/media/TipsTableTent.4101b516.png";